import { toRef, ref, computed, watch, resolveComponent, createElementBlock, openBlock, normalizeClass, unref, createElementVNode, createCommentVNode, renderSlot, createVNode, createBlock, withCtx, createTextVNode, toDisplayString, mergeProps, Fragment, renderList } from "vue";
import { isObject } from "lodash-es";
import "moment";
import { uuid } from "../../utils/uuid.js";
import { useField } from "vee-validate";
import "../../plugins/apollo.js";
import "../../constants/UserPolicy.js";
import "pinia";
import "../../store/index.js";
import { useI18n } from "../../plugins/i18n.js";
import "../../assets/e94e4817134d7c25.png";
import "../../assets/5341da3ffbec0137.png";
import "../../assets/01f50022317dccd7.png";
import "axios";
import "vue-router";
import "maska";
import "../../graphql/queries.js";
import "../../graphql/subscriptions.js";
import "vuetify";
import "vue-social-sharing";
import "@duannx/vue-client-only";
import "vuetify/components/VSnackbar";
import "../../assets/3448554beb4b633a.svg";
import "vuetify/components/VImg";
import "../../constants/components/index.js";
/* empty css                         */
import "vuetify/components/VDialog";
import "../../graphql/mutations.js";
import "sweetalert2";
import "@vee-validate/i18n";
/* empty css                        */
import "vuetify/components/VCard";
import "vuetify/components/VOverlay";
import "vuetify/components/VProgressCircular";
/* empty css                                  */
import "vuetify/components/VDivider";
import "vuetify/components/VList";
import "../../assets/8a32dc557a826bf0.png";
/* empty css               */
import "../../graphql/navigation-menu.js";
import "vuetify/components/VSkeletonLoader";
/* empty css                                 */
import "vuetify/components/VBtn";
import "vuetify/components/VNavigationDrawer";
import "vuetify/components/VMenu";
import "../Auth/AppleAuthButton/AppleAuthButton.js";
import "../Auth/FacebookAuthButton/FacebookAuthButton.js";
import "../Auth/GoogleAuthButton/GoogleAuthButton.js";
import "../Auth/InstagramAuthButton/InstagramAuthButton.js";
import "../Auth/TelegramAuthButton/TelegramAuthButton.js";
/* empty css                               */
import "vuetify/components/VGrid";
import "./index.js";
import "vuex";
/* empty css                        */
import "vuetify/components/VIcon";
import "vuetify/components/VProgressLinear";
import "vuetify/components/transitions";
import "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import "../../icons/mdi/index.js";
/* empty css                            */
import { VBtnToggle } from "vuetify/components/VBtnToggle";
import "../../assets/6f5dc1ff0a697731.svg";
import "../../assets/888bb8db73be3c15.svg";
/* empty css                             */
import "vuetify/components/VInfiniteScroll";
/* empty css                                  */
/* empty css                */
import "vuetify/components/VChip";
/* empty css                          */
import "../HtmlEditor/index.js";
import "../Messages/vue-advanced-chat/lib/RoomsList/RoomContent/RoomContent.vue.js";
import "../Messages/vue-advanced-chat/lib/Room/Room.vue.js";
/* empty css                                               */
/* empty css                        */
import "../News/NewsModule/NewsModule.vue.js";
import "../News/NewsModule/NewsList.vue.js";
import "../../graphql/news.js";
/* empty css                  */
import "../Pages/index.js";
import "vue3-runtime-template";
import "ckeditor5/ckeditor5.css";
/* empty css                                 */
import "vuetify/components/VWindow";
import "../../assets/5a0af7dd23957928.png";
import { useTheme } from "../../composables/useTheme.js";
import "../../graphql/system-settings.js";
import "tiny-emitter/instance";
/* empty css                       */
/* empty css                                    */
import "vuetify/components/VHover";
import "../../constants/NewsGroup.js";
/* empty css                                     */
import "vuetify/components/VTabs";
import "vuetify/directives";
import "@iconify/vue";
import "mobile-device-detect";
/* empty css                                   */
import "vuetify/components/VBottomSheet";
import "../../graphql/favorites.js";
import "../../plugins/tracker/page-tracker.js";
/* empty css                             */
import "../../graphql/notifications.js";
/* empty css                                  */
import "../../constants/CommunicationChannels.js";
/* empty css                      */
import "vuetify/components/VColorPicker";
/* empty css                                                */
import "vuetify/components/VTextarea";
/* empty css                                             */
/* empty css                          */
import "graphql-tag";
import "../../graphql/entity.js";
import "../../graphql/lookups.js";
/* empty css                       */
import "vuetify/components";
/* empty css                             */
/* empty css               */
import "../../graphql/system-events.js";
/* empty css                                        */
/* empty css                   */
import "vuetify/components/VTooltip";
/* empty css                         */
import "vuetify/components/VCombobox";
import "vuetify/components/VExpansionPanel";
import "vuetify/components/VTable";
import "../../graphql/files.js";
/* empty css                      */
import "vuetify/components/VForm";
/* empty css                                 */
/* empty css                                               */
import "vuetify/components/VAlert";
/* empty css                                    */
import "vue-dndrop";
/* empty css                                            */
/* empty css                                    */
import "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
/* empty css                  */
import "vuetify/components/VFileInput";
/* empty css                            */
import "vuetify/components/VAvatar";
/* empty css                                  */
import "vuetify/components/VTextField";
import "vuetify/components/VTimeline";
/* empty css                              */
import "../../graphql/public-articles.js";
/* empty css                                           */
/* empty css                         */
import "vuetify/components/VChipGroup";
import "vuetify/components/VSelect";
import "vuetify/components/VSheet";
/* empty css                            */
import "vuetify/components/VItemGroup";
/* empty css                       */
import "vuetify/components/VCheckbox";
import "vuetify/components/VRadio";
import "vuetify/components/VRadioGroup";
import "cronstrue/i18n";
import "cron-parser";
/* empty css                  */
import "../../graphql/quartz.js";
import "vue-i18n";
import "../../graphql/integration-systems.js";
import "../../constants/IntegrationSystemLogDirection.js";
/* empty css                                                      */
/* empty css                                    */
import "../../graphql/session-store.js";
import "../../composables/useModalPage.js";
import "../../icons/portal/index.js";
/* empty css                       */
import { VLabel } from "vuetify/components/VLabel";
const _hoisted_1 = {
  key: 0,
  class: "v-input--error"
};
const _hoisted_2 = { class: "v-input__details" };
const _hoisted_3 = {
  class: "v-messages theme--dark text-error",
  role: "alert"
};
const _hoisted_4 = { class: "v-messages__wrapper" };
const _hoisted_5 = { class: "v-messages__message" };
const _sfc_main = {
  __name: "BanzaButtonToggle",
  props: {
    modelValue: {
      default: null
    },
    preset: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    items: {
      type: [Array],
      required: true
    },
    itemValue: {
      type: String,
      default: "id"
    },
    itemTitle: {
      type: String,
      default: "name"
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    mandatory: {
      type: Boolean,
      default: true
    },
    rules: {
      type: [Array, String],
      default: null
    },
    density: {
      type: String,
      default: "default"
    },
    align: {
      type: String,
      default: "center"
    },
    color: {
      type: String,
      default: "primary"
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const { t } = useI18n();
    const props = __props;
    const { value, errorMessage } = useField(
      () => props.name || uuid(),
      toRef(() => props.rules),
      {
        label: props.label,
        syncVModel: true
      }
    );
    const innerValue = ref(
      isObject(value.value) ? value.value[props.itemValue] : value.value
    );
    const onModelValueUpdate = (val) => {
      innerValue.value = val;
      if (props.returnObject) {
        const item = props.items.find((item2) => item2[props.itemValue] === val);
        value.value = item ? {
          [props.itemValue]: item[props.itemValue],
          [props.itemTitle]: item[props.itemTitle]
        } : null;
      } else {
        value.value = val;
      }
    };
    const getItemDisplayName = (item) => {
      if (isObject(item)) {
        return item.lczKey ? t(item.lczKey) : item[props.itemTitle];
      }
      return item;
    };
    const { className, attrsWithoutClass, resolveColor } = useTheme({
      componentKey: "BanzaButtonToggle",
      presetName: toRef(() => props.preset)
    });
    const colorCss = computed(
      () => resolveColor(attrsWithoutClass.value.color || props.color)
    );
    watch(value, (val) => {
      innerValue.value = props.returnObject && isObject(val) ? val[props.itemValue] : val;
    });
    return (_ctx, _cache) => {
      const _component_b_icon = resolveComponent("b-icon");
      const _component_b_btn = resolveComponent("b-btn");
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["banza-btn-toggle", unref(className)])
      }, [
        createElementVNode("div", {
          class: normalizeClass([
            "banza-btn-toggle__wrapper d-flex justify-space-between ga-3",
            `align-${__props.align}`
          ])
        }, [
          renderSlot(_ctx.$slots, "label", {}, () => [
            __props.label && !__props.hideLabel ? (openBlock(), createBlock(VLabel, {
              key: 0,
              class: "banza-btn-toggle__label"
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(__props.label), 1)
              ]),
              _: 1
            })) : createCommentVNode("", true)
          ]),
          createVNode(VBtnToggle, mergeProps({
            style: {
              ["border"]: `2px solid ${unref(colorCss)}`
            },
            "model-value": unref(innerValue),
            mandatory: __props.mandatory,
            density: __props.density,
            disabled: __props.disabled
          }, unref(attrsWithoutClass), { "onUpdate:modelValue": onModelValueUpdate }), {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(__props.items, (item, index) => {
                return openBlock(), createBlock(_component_b_btn, {
                  key: index,
                  value: __props.itemValue ? item[__props.itemValue] : index,
                  active: __props.itemValue ? item[__props.itemValue] === unref(innerValue) : item === unref(innerValue),
                  color: unref(colorCss),
                  variant: "flat"
                }, {
                  default: withCtx(() => [
                    item.iconAttrs || item.icon ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                      item.iconAttrs ? (openBlock(), createBlock(_component_b_icon, mergeProps({
                        key: 0,
                        ref_for: true
                      }, item.iconAttrs), null, 16)) : (openBlock(), createBlock(_component_b_icon, {
                        key: 1,
                        icon: item.icon
                      }, null, 8, ["icon"]))
                    ], 64)) : createCommentVNode("", true),
                    createTextVNode(" " + toDisplayString(getItemDisplayName(item)), 1)
                  ]),
                  _: 2
                }, 1032, ["value", "active", "color"]);
              }), 128))
            ]),
            _: 1
          }, 16, ["style", "model-value", "mandatory", "density", "disabled"])
        ], 2),
        unref(errorMessage) ? (openBlock(), createElementBlock("div", _hoisted_1, [
          createElementVNode("div", _hoisted_2, [
            createElementVNode("div", _hoisted_3, [
              createElementVNode("div", _hoisted_4, [
                createElementVNode("div", _hoisted_5, toDisplayString(unref(errorMessage)), 1)
              ])
            ])
          ])
        ])) : createCommentVNode("", true)
      ], 2);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
